<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <div v-if="professionals.length">
      <div class="flex flex-wrap">
        <div
          v-for="(professional, i) in professionals"
          :key="i"
          class="rounded bg-white shadow-md flex flex-wrap items-center text-center md:text-left p-4 m-2 w-full justify-around md:justify-start scale-hover"
        >
          <span
            class=" professional-avatar m-auto md:m-2"
            :style="{backgroundImage: `url('${professional.profilePictureUrl || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${professional.name}+${professional.lastName}`} ')` }"
          />
          <div class="flex flex-col items-center md:items-start mx-2" >
            <h2 class="text-center md:text-left my-2">
              {{ professional.name }} {{ professional.lastName }}
            </h2>
            <span>
              {{ professional.title }}
            </span>
            <!-- Address -->
            <div
              v-if="professional.address"
              class="text-center md:text-left titlecase flex flex-col md:flex-row my-2"
            >
              <b-icon
                icon="map-marker"
                class="tag-text my-2 md:my-0"
              />
              <div class="text-center md:text-left">
                <strong>
                  {{professional.address.street}}, {{professional.address.number}} - {{professional.address.neighborhood}}

                  {{ professional.address.city }} {{ professional.address.state && ` - ${professional.address.state}`}}
                </strong>
              </div>
            </div>

            <!-- Tags -->
            <div class="professional-card-specialties flex flex-wrap justify-center md:justify-start my-2">
              <span
                class="tag-light"
                v-for="(specialty, index) in professional.specialties"
                :key="index"
              ><span class="tag-text">{{specialty}}</span></span>
            </div>
            <!-- Button -->
            <div class="text-left items-start">
              <router-link
                :to="`/profiles/${professional.userId}`"
                class="button mr-2 my-2 is-primary w-16"
              >
                <b-tooltip label="Ver Perfil">
                  <b-icon icon="eye" />
                </b-tooltip>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h2 class="text-center my-4">Nenhum Profissional Encontrado.</h2>
      <h3 class="text-center">Seja o primeiro profissional cadastrado na sua região. <strong>
          <router-link to="/signup">Cadastre-se</router-link>
        </strong> agora mesmo.</h3>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase/app'
import { professionalsGeoCollection } from '../firebaseConfig'
import { getCoordinatesFromLocationNameMixin } from '../mixins/location.methods'
import _ from 'lodash'
export default {
  props: {
    location: String,
    maxDistance: Number,
    tags: Array
  },
  mixins: [getCoordinatesFromLocationNameMixin],
  data () {
    return {
      performingRequest: false,
      professionals: []
    }
  },
  async mounted () {
    try {
      this.performingRequest = true
      const {
        Latitude: lat,
        Longitude: lng
      } = await this.getCoordinatesFromLocationName(this.location)
      this.professionals = await this.getProfessoinalsByLocationAndTags(lat, lng, this.maxDistance, this.tags)
    } catch (error) {
      console.error(error)
    } finally {
      this.performingRequest = false
    }
  },
  methods: {
    async getProfessoinalsByLocationAndTags (lat, lng, radius, tags) {
      try {
        const professionalsQuerySnapshot = professionalsGeoCollection.near({
          center: new firebase.firestore.GeoPoint(lat, lng),
          radius: radius
        })

        let professionals = []

        const docs = await professionalsQuerySnapshot.get()

        if (!docs.empty) {
          docs.forEach(doc => {
            professionals.push(doc.data())
          })
        }

        if (tags && tags.length > 0) {
          professionals = tags.reduce((matches, tag) => {
            const professionalsFromTag =
              professionals.filter(professional => {
                return professional.specialties
                  .some(specialty => {
                    return tag.localeCompare(specialty, undefined, { sensitivity: 'base' }) === 0
                  })
              })
            matches = _.unionBy(matches, professionalsFromTag, 'userId')
            return matches
          }, [])
        }

        return await professionals
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
